import React, { useId } from "react";

import { prizeMatches } from "./odds";

// Keep the original artwork and its aspect ratio. Mask only the baked-in odds
// so the replacement text scales with the artwork at every screen size.
const OddsArtwork = ({ src, odds, mobile = false, className }) => {
  const maskId = useId();
  const width = mobile ? 703 : 2606;
  const height = mobile ? 1493 : 1516;
  const x = mobile ? 160 : 2058;
  const cellWidth = mobile ? 416 : 414;
  const centers = mobile
    ? [171, 327, 483, 639, 795, 951, 1107, 1263, 1419]
    : [187, 344, 500, 657, 813, 970, 1126, 1283, 1439];

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      className={className}
      style={{ height: "auto" }}
      role="img"
      aria-label="Хонжворын магадлал"
    >
      <defs>
        <mask
          id={maskId}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width={width}
          height={height}
        >
          <rect width={width} height={height} fill="white" />
          {centers.map((y) => (
            <rect
              key={y}
              x={x}
              y={y - 45}
              width={cellWidth}
              height="90"
              fill="black"
            />
          ))}
        </mask>
      </defs>
      <image
        href={src}
        width={width}
        height={height}
        mask={`url(#${maskId})`}
      />
      {centers.map((y, index) => {
        const value = odds?.[index];
        const label =
          value == null
            ? "—"
            : Number.isFinite(value)
            ? `1:${Math.round(value).toLocaleString("en-US")}`
            : "—";
        const [matches, mega] = prizeMatches[index];
        return (
          <g key={y}>
            <title>{`${matches} бөмбөг${
              mega ? " + Mega Ball" : ""
            }: ${label}`}</title>
            {index % 2 === 0 && (
              <rect
                x={x}
                y={y - 45}
                width={cellWidth}
                height="90"
                fill="white"
              />
            )}
            <text
              x={x + cellWidth / 2}
              y={y}
              dy="0.35em"
              textAnchor="middle"
              fill="#353F4A"
              fontFamily="Inter, sans-serif"
              fontWeight="600"
              fontSize={mobile ? 58 : 56}
            >
              {label}
            </text>
          </g>
        );
      })}
    </svg>
  );
};

export default OddsArtwork;
